import { BY_ID, MODES } from './roster.js';
import { clamp } from './math.js';

export const PROTOCOL = 2;
export const CLOSE = Object.freeze({ POLICY: 1008, REPLACED: 4001, IDLE: 4002 });
export const terminalClose = code => [CLOSE.POLICY, CLOSE.REPLACED, CLOSE.IDLE].includes(code);
const owns = (catalog, value) => typeof value === 'string' && Object.hasOwn(catalog, value);

export function cleanName(value) {
  return typeof value === 'string'
    ? value.replace(/[\u0000-\u001f\u007f<>]/g, '').trim().slice(0, 18) || 'Snow Rookie'
    : 'Snow Rookie';
}

/** Accept only player intentions. Catalog lookups must reject inherited object keys. */
export function parseMessage(raw) {
  if (typeof raw !== 'string' || raw.length > 2048) return null;
  let d;
  try { d = JSON.parse(raw); } catch { return null; }
  if (!d || typeof d !== 'object' || Array.isArray(d)) return null;
  if (d.type === 'input') {
    if (!Number.isSafeInteger(d.seq) || d.seq < 0 || d.seq > 1e12) return null;
    if (!['x', 'z', 'ax', 'az'].every(k => typeof d[k] === 'number' && Number.isFinite(d[k]))) return null;
    let x = clamp(d.x, -1, 1), z = clamp(d.z, -1, 1), m = Math.hypot(x, z);
    if (m > 1) { x /= m; z /= m; }
    let ax = clamp(d.ax, -1, 1), az = clamp(d.az, -1, 1), a = Math.hypot(ax, az);
    if (a > .001) { ax /= a; az /= a; } else { ax = 0; az = -1; }
    return { type: 'input', seq: d.seq, x, z, ax, az, fire: d.fire === true, super: d.super === true,
      gadget: d.gadget === true, aim: clamp(Number.isFinite(d.aim) ? d.aim : 1, .15, 1) };
  }
  if (d.type === 'join' && owns(BY_ID, d.character)) {
    return { type: 'join', character: d.character, name: cleanName(d.name), mode: owns(MODES, d.mode) ? d.mode : 'gift', version: d.version };
  }
  if (d.type === 'select' && owns(BY_ID, d.character)) return { type: 'select', character: d.character };
  if (d.type === 'mode' && owns(MODES, d.mode)) return { type: 'mode', mode: d.mode };
  if (['ready', 'start', 'rematch', 'ping'].includes(d.type)) return { type: d.type, at: Number.isFinite(d.at) ? d.at : 0 };
  return null;
}
